module.exports = __webpack_public_path__ + "static/media/kw.0a1e78f0.svg";